import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";

import { isAxiosError } from "axios";
import { BEVersion } from "../api/FetchAPI";
import { showConnectionError } from "../promptMessages/PromptMessages";
import { ALERTMSG } from "../lib/enums";

interface AppContextType {
  beversion: string | null;
}

export const VersionContext = createContext<AppContextType>({
  beversion: null,
});

export const VersionProvider: React.FC<React.PropsWithChildren<{}>> = ({
  children,
}) => {
  const [beversion, setBEVersion] = useState<string | null>(null);
  const fetched = useRef(false);

  useEffect(() => {
    const fetchBEVersion = async () => {
      try {
        const version: any = await BEVersion();
        setBEVersion(version);
      } catch (error: any) {
        const code = isAxiosError(error)
          ? error.request.status || error.code
          : error.response.status || error.code;

        showConnectionError(
          isAxiosError(error)
            ? ALERTMSG.SERVDISRUPTION
            : ALERTMSG.UNDHANDLEDERR,
          `(${code})`,
          "error",
          "",
          "#d32f2f"
        );
      }
    };

    if (!fetched.current) {
      fetched.current = true;
      fetchBEVersion();
    }
  }, []);

  return (
    <VersionContext.Provider value={{ beversion }}>
      {children}
    </VersionContext.Provider>
  );
};

export const useAppContext = () => useContext(VersionContext);
